// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__WtkU5","title":"InfoRow_title__2ZRXv"};